var o = Object.defineProperty;
var l = (s, e, t) => e in s ? o(s, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : s[e] = t;
var d = (s, e, t) => l(s, typeof e != "symbol" ? e + "" : e, t);
class u {
  constructor(e) {
    d(this, "knock");
    this.knock = e;
  }
  async get(e) {
    const t = await this.knock.client().makeRequest({
      method: "GET",
      url: `/v1/messages/${e}`
    });
    return this.handleResponse(t);
  }
  async updateStatus(e, t, a) {
    const n = t === "interacted" && a ? { metadata: a.metadata } : void 0, r = await this.knock.client().makeRequest({
      method: "PUT",
      url: `/v1/messages/${e}/${t}`,
      data: n
    });
    return this.handleResponse(r);
  }
  async removeStatus(e, t) {
    const a = await this.knock.client().makeRequest({
      method: "DELETE",
      url: `/v1/messages/${e}/${t}`
    });
    return this.handleResponse(a);
  }
  async batchUpdateStatuses(e, t, a) {
    const n = t === "interacted" && a ? { metadata: a.metadata } : {}, r = await this.knock.client().makeRequest({
      method: "POST",
      url: `/v1/messages/batch/${t}`,
      data: { message_ids: e, ...n }
    });
    return this.handleResponse(r);
  }
  async bulkUpdateAllStatusesInChannel({
    channelId: e,
    status: t,
    options: a
  }) {
    const n = await this.knock.client().makeRequest({
      method: "POST",
      url: `/v1/channels/${e}/messages/bulk/${t}`,
      data: a
    });
    return this.handleResponse(n);
  }
  handleResponse(e) {
    var t, a;
    if (e.statusCode === "error") {
      if (((a = (t = e.error) == null ? void 0 : t.response) == null ? void 0 : a.status) < 500)
        return e.error || e.body;
      throw new Error(e.error || e.body);
    }
    return e.body;
  }
}
export {
  u as default
};
//# sourceMappingURL=index.mjs.map
